//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    resultName: {
      type: String,
      default: ''
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    objectLabel: {
      type: String,
      default: null
    },
    objectClass: {
      type: [String, Object],
      default: null
    },
    resultClass: {
      type: [String, Object],
      default: null
    },
    additionalRules: {
      type: Array,
      default: null
    }
  },
  computed: {
    rules: function () {
      const rules = [val => !this.readonly && this.required ? !!val : true]
      if (this.additionalRules && this.additionalRules.length) {
        rules.push(...this.additionalRules)
      }
      return rules
    }
  }
}

